export const substituteUrlParams = (template, obj) =>
  template.replace(/\${([a-z0-9_]+)}/gi, (match, capture) => obj[capture]);
